// extracted by mini-css-extract-plugin
export default {"container":"style_container__CDVFf","block":"style_block__2vj+R","copy":"style_copy__q+7-N","copyText":"style_copyText__aNidS"};